/**
 * 알림 API
 */
import apiClient from './client';

export interface Notification {
  _id: string;
  userId: string;
  type: 'like' | 'comment' | 'bookmark' | 'follow' | 'system';
  message: string;
  read: boolean;
  link?: string;
  createdAt: string;
  /** 하위 호환 — 구 스키마 필드 */
  actorName?: string;
  albumId?: string;
  albumTitle?: string;
  preview?: string;
}

export const getNotifications = async (limit = 20): Promise<Notification[]> => {
  const { data } = await apiClient.get<Notification[]>('/notifications', { params: { limit } });
  return data;
};

export const getUnreadCount = async (): Promise<number> => {
  const { data } = await apiClient.get<{ count: number }>('/notifications/unread-count');
  return data.count;
};

export const markAsRead = async (id: string): Promise<void> => {
  await apiClient.post(`/notifications/${id}/read`);
};

export const markAllAsRead = async (): Promise<void> => {
  await apiClient.post('/notifications/read-all');
};
